import stripLeadingZero from './strip-leading-zero';
import stripNonNumeric from './strip-non-numeric';

export default (value) => Number(stripLeadingZero(stripNonNumeric(value)));
